import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { T_GeneralAppElementsSlice } from "./GeneralAppElements_Types";

const initialState: T_GeneralAppElementsSlice = {
  masterData: {
    masterDetail: undefined,
    productCategory: [],
    supportDataList: [],
  },
  selectedTab: "",
  moduleList: [],
  parentModuleList: [],
  selectedModule: "",
  selectedCategory: "",
  categoryList: [],
  faqList: [],
  appPermission: undefined,
  userProfileDetails: {
    profileId: 0,
    profileName: "",
    csUserId: "",
    featureDetailsList: [],
    menuDetailsList: [],
  },
  quickActionMenu: {},
  isDowntimeForServiceMenuItem: false,
  taxCenterFlow: false,
  selectedTaxCenterFlow: "",
  unifiedOfferDetails: undefined,
  isOfferMartApiRunning: false,
  isNoHolding: false,
  isConsentReceived: false,
};

export const GeneralAppElementsSlice = createSlice({
  name: "GeneralAppElementsSlice",
  initialState,
  reducers: {
    setMasterData: (state, action) => {
      return {
        ...state,
        masterData: action.payload,
      };
    },
    setSelectedTab: (state, action) => {
      return {
        ...state,
        selectedTab: action.payload,
      };
    },
    setParentModuleList: (state, action) => {
      return {
        ...state,
        parentModuleList: action.payload,
      };
    },
    setModuleList: (state, action) => {
      return {
        ...state,
        moduleList: action.payload,
      };
    },
    setSelectedModule: (state, action) => {
      return {
        ...state,
        selectedModule: action.payload,
      };
    },
    setCategoryList: (state, action) => {
      return {
        ...state,
        categoryList: action.payload,
      };
    },
    setSelectedCategory: (state, action) => {
      return {
        ...state,
        selectedCategory: action.payload,
      };
    },
    setFaqList: (state, action) => {
      return {
        ...state,
        faqList: action.payload,
      };
    },
    setAppPermission: (state, action) => {
      return {
        ...state,
        appPermission: action.payload,
      };
    },
    setUserProfileDetails: (state, action) => {
      return {
        ...state,
        userProfileDetails: action.payload,
      };
    },
    updateQuickActionMenuData: (state, action) => {
      return {
        ...state,
        quickActionMenu: action.payload,
      };
    },
    setIsDowntimeForServiceMenuItem: (state, action) => {
      return {
        ...state,
        isDowntimeForServiceMenuItem: action.payload,
      };
    },
    setTaxCenterFlow: (state, action) => {
      return {
        ...state,
        taxCenterFlow: action.payload,
      };
    },
    setSelectedTaxCenterFlow: (state, action) => {
      return {
        ...state,
        selectedTaxCenterFlow: action.payload,
      };
    },
    setIsOfferMartApiRunning: (state, action) => {
      return {
        ...state,
        isOfferMartApiRunning: action.payload,
      };
    },
    setUnifiedOfferDetails: (state, action) => {
      return {
        ...state,
        unifiedOfferDetails: action.payload,
      };
    },
    setIsNoHolding: (state, action) => {
      return {
        ...state,
        isNoHolding: action.payload,
      };
    },
    setIsConsentReceived: (state, action) => {
      return {
        ...state,
        isConsentReceived: action.payload,
      };
    },
  },
});

export const GeneralAppElementsReducer = GeneralAppElementsSlice.reducer;
export const GeneralAppElementsSliceKey = GeneralAppElementsSlice.reducerPath;
export const {
  setMasterData,
  setSelectedTab,
  setParentModuleList,
  setModuleList,
  setSelectedModule,
  setCategoryList,
  setSelectedCategory,
  setFaqList,
  setAppPermission,
  setUserProfileDetails,
  updateQuickActionMenuData,
  setIsDowntimeForServiceMenuItem,
  setTaxCenterFlow,
  setSelectedTaxCenterFlow,
  setIsOfferMartApiRunning,
  setUnifiedOfferDetails,
  setIsNoHolding,
  setIsConsentReceived,
} = GeneralAppElementsSlice.actions;
